import { Box } from "@mui/material"
import type { SxProps, Theme } from "@mui/material"

export function FolderIcon({ isProject, sx }: { isProject?: boolean; sx?: SxProps<Theme> }) {
    const bg = isProject ? '#FECC27' : 'rgb(28, 153, 255)'
    const afterBg = isProject ? '#F4B632' : 'rgb(52, 111, 163)'
    return (
        <Box
            className="kbFolderIcon"
            sx={[{
                bgcolor: bg,
                borderRadius: '4px',
                width: 30,
                height: 20,
                position: 'relative',
                scale: 0.75,
                mt: '3px',
                flexShrink: 0,
                '&::before': {
                    content: '""',
                    marginTop: '-4px',
                    position: 'absolute',
                    left: 0,
                    bgcolor: bg,
                    borderRadius: '4px',
                    borderBottomLeftRadius: '8px',
                    width: '12px',
                    height: '24px',
                },
                '&::after': {
                    content: '""',
                    bgcolor: afterBg,
                    borderRadius: '4px',
                    width: '30px',
                    height: '20px',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    transform: 'skewX(0deg)',
                    opacity: 0,
                    transition: '0.2s',
                },
            }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
        />
    )
}